import { useEffect, useRef, useState } from "react";

const useCountDown = ({ initialSeconds }) => {
    const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
    const [isRunning, setIsRunning] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        if (!isRunning) return;

        timerRef.current = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    setIsRunning(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timerRef.current);
    }, [isRunning]);

    const start = (seconds = initialSeconds) => {
        clearInterval(timerRef.current);
        setSecondsLeft(seconds);
        setIsRunning(true);
    };

    const reset = () => {
        clearInterval(timerRef.current);
        setSecondsLeft(initialSeconds);
        setIsRunning(false);
    };

    return { secondsLeft, isRunning, start, reset };
}

export default useCountDown